import { motion } from "framer-motion";
import { Sparkles, Check, X } from "lucide-react";

/**
 * SmartSuggestion — strip horizontal com border-left colorido + gradient
 * sutil pro transparente. Botões aceitar/recusar opcionais (renderiza só
 * se onAccept ou onReject forem passados).
 *
 * Props:
 *   tone     — 'info' | 'success' | 'warning'
 *   message  — string
 *   onAccept?— callback "sim, faz isso"
 *   onReject?— callback "não, descarta"
 *   acceptLabel?, rejectLabel?
 */
const TONE = {
  info:    { border: "border-l-semantic-info",    grad: "from-semantic-info/15",    icon: "text-semantic-info" },
  success: { border: "border-l-semantic-success", grad: "from-semantic-success/15", icon: "text-semantic-success" },
  warning: { border: "border-l-semantic-warning", grad: "from-semantic-warning/15", icon: "text-semantic-warning" },
};

export default function SmartSuggestion({
  tone = "info",
  message,
  onAccept,
  onReject,
  acceptLabel = "sim",
  rejectLabel = "não",
}) {
  const t = TONE[tone] || TONE.info;
  const hasActions = onAccept || onReject;

  return (
    <motion.div
      initial={{ opacity: 0, x: -3 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.25 }}
      className={`relative flex items-center gap-3 pl-3 pr-3 py-2 rounded-md border-l-2 ${t.border} bg-gradient-to-r ${t.grad} to-transparent`}
      data-testid="ds-smart-suggestion"
    >
      <Sparkles className={`w-3.5 h-3.5 shrink-0 ${t.icon}`} />
      <p className="flex-1 text-[13px] text-slate-300 leading-snug">{message}</p>
      {hasActions ? (
        <div className="flex items-center gap-1 shrink-0">
          {onAccept ? (
            <button
              type="button"
              onClick={onAccept}
              className="text-[11px] flex items-center gap-1 px-2 py-1 rounded-md bg-semantic-success/10 hover:bg-semantic-success/20 text-semantic-success transition-colors"
              data-testid="ds-suggestion-accept"
            >
              <Check className="w-3 h-3" /> {acceptLabel}
            </button>
          ) : null}
          {onReject ? (
            <button
              type="button"
              onClick={onReject}
              className="text-[11px] flex items-center gap-1 px-2 py-1 rounded-md bg-white/5 hover:bg-white/10 text-slate-400 transition-colors"
              data-testid="ds-suggestion-reject"
            >
              <X className="w-3 h-3" /> {rejectLabel}
            </button>
          ) : null}
        </div>
      ) : null}
    </motion.div>
  );
}
